// Les 4 valeurs officielles du CMP Lubumbashi.
export const VALEURS: string[] = ['Sainteté', 'Obéissance', 'Intimité', 'Service']
